<template>
    <div>
        <b-loading :active="loading"></b-loading>
        <div class="section">
            <h1 class="title is-uppercase">{{ __('strings.user.form.title') }}</h1>
        </div>

        <div class="section">
            <b-message v-if="sended.msg"  v-bind:type="sended.type" has-icon>
                <p v-text="sended.msg"></p>
            </b-message>
            <b-message v-if="hasErrors" type="is-danger" has-icon>
                <p v-for="(message, field) in errors" v-text="message" :key="field"></p>
            </b-message>
        </div>

        <div id="source-form" class="section">
            <div class="columns">
                <div class="column">
                    <b-field :label="__('strings.user.form.name')" label-position="on-border"
                             :type="{ 'is-danger': errors.name }" :message="errors.name">
                        <b-input :placeholder="__('strings.user.form.name')" type="name" name="name"
                                 v-bind:disabled="isDisabled" v-model="input.name" @focus="clearError">
                        </b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field :label="__('strings.user.form.email')"
                             label-position="on-border"
                             :type="{ 'is-danger': errors.email }"
                             :message="errors.email">
                        <b-input :placeholder="__('strings.user.form.email')"
                                 type="email" name="email" v-bind:disabled="isDisabled"
                                 v-model="input.email" @focus="clearError"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field :label="__('strings.user.form.role')" label-position="on-border"
                             :type="{ 'is-danger': errors.role }" :message="errors.role">
                        <b-select v-model="input.role" name="role" icon="account" expanded :loading="loading">
                            <option v-for="(role, index) in roles" :key="index" :value="role.id">
                                {{ucFirst(cleanString(role.name))}}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-2">
                    <div class="buttons is-right">
                        <b-button tag="button" type="is-success" class="is-uppercase"  @click.prevent="submit"
                                  :label="__('strings.user.roles.form.submitButton')" icon-left="content-save"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            hasErrors: false,
            isSelected: false,
            isDisabled: false,
            input: {
                name: "",
                email: "",
                role: "",
            },
            errors: {
                name: "",
                role: ""
            },
            userRole: "--",
            userRoleId: "",
            sended: {
                msg: '',
                type: ''
            },
            roles: {}
        };
    },
    mounted() {
        if (this.$route.params.action === "create") {
            this.getRoles();
        }
        if (this.$route.params.hasOwnProperty('routeKey') && this.$route.params.routeKey) {
            axios.get('/users/edit/' + this.$route.params.routeKey)
            .then(response => {
                for (const [key, value] of Object.entries(response.data)) {
                    if (this.input.hasOwnProperty(key)) {
                        this.input[key] = value;
                    }
                }
                this.input = response.data;
                if (this.input.roles.length) {
                    this.userRole = this.input.roles[0].name;
                    this.input.role = this.input.roles[0].id;
                }
                this.isSelected = true;
                this.getRoles();
                this.isDisabled = true;
                this.loading = false;
            })
        }
    },
    methods: {
        submit() {
            this.loading = true;
            let method = this.$route.params.action === "create" ? 'post' : 'patch';
            let url = this.$route.params.action === "edit" ? `/update/users/${this.$route.params.routeKey}` : '/store/users';
            axios({method, url, data: this.input})
                .then(response => {
                    this.sended = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    for (const [key, value] of Object.entries(error.response.data.errors)) {
                        this.errors[key] = value[0];
                    }
                    this.hasErrors = true;
                    this.loading = false;
                });
        },
        clearError(event) {
            this.errors[event.target.name] = "";
            this.hasErrors = false;
        },
        getRoles() {
            axios.get('/users/roles')
                .then(response => {
                    this.roles = response.data;
                    this.loading = false;
                });
        }
    }
};
</script>
